import React from 'react';
import PropTypes from 'prop-types';
import Crossword from './crossword';
import CodeEditor from '../CodeEditor';

class CrosswordEditor extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      schema: this.props.schema
    };

    this.onSchemaChange = this.onSchemaChange.bind(this);
  }

  reveal (e) {
    e.preventDefault();
    this.crossword.onSolution();
  }

  clearAll (e) {
    e.preventDefault();
    this.crossword.onClearAll();
  }

  onSchemaChange (schema) {
    this.setState({
      schema: JSON.parse(schema)
    });
  }

  inputValue = () => JSON.stringify(this.state.schema)

  getDimensions () {
    let maxCol = 0;
    let maxRow = 0;

    this.state.schema.map(item => {
      if (!item.position) return;

      const x = item.direction == "across" ? item.position.x + item.length : item.position.x + 1;
      const y = item.direction == "down" ? item.position.y + item.length : item.position.y + 1;

      if (x > maxCol) maxCol = x;
      if (y > maxRow) maxRow = y;
    });

    return {
      cols: maxCol,
      rows: maxRow,
    };
  }

  render() {
    return (
      <div className={this.props.class}>
        { this.props.input_name && (<input type="hidden" name={this.props.input_name} value={this.inputValue()} />) }

        {this.props.editable && (
          <div className="border border-grey-mid rounded-lg mb-6">
            <CodeEditor
              changeOnBlur
              code={this.inputValue(this.props.schema)}
              onChange={this.onSchemaChange}
            />
          </div>
        )}

        <div className={`${this.props.crossword_class} h-full`}>
          <Crossword
            ref={(element) => { this.crossword = element; }}
            controls={false}
            endpoint={this.props.endpoint}
            editable={this.props.editable}
            completed={this.props.completed}
            value={this.props.value}
            start_at={this.props.start_at}
            end_at={this.props.end_at}
            state={this.props.state}
            data={
              {
                id: this.props.crossword_id,
                entries: this.state.schema,
                dimensions: this.getDimensions(),
                crosswordType: 'quick',
              }
            }
          />
        </div>
      </div>
    );
  }
}

CrosswordEditor.propTypes = {
  crossword_id: PropTypes.string,
  editable: PropTypes.bool,
  input_name: PropTypes.string,
  schema: PropTypes.array,
  value: PropTypes.array,
  completed: PropTypes.array,
  start_at: PropTypes.string,
  end_at: PropTypes.string,
  state: PropTypes.string,
  class: PropTypes.string,
};

CrosswordEditor.defaultProps = {
  value: [],
  completed: [],
  schema: [],
  editable: false,
  class: "",
  state: "retry"
};

export default CrosswordEditor;
